import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./CollectionCard.css";
import { collectionUrl } from "../../../util/url";

/**
 * 컬렉션 카드 컴포넌트
 * 각 컬렉션의 이미지와 정보를 표시합니다.
 */
const CollectionCard = ({ collection, priority = false }) => {
  const { title, subtitle, resizedSmallImage, sub_header } = collection;

  return (
    <li className="CollectionCard">
      <Link to={collectionUrl(collection)} aria-label={title}>
        <div className="CollectionCard-image-container">
          <img
            src={resizedSmallImage}
            alt={title}
            className="CollectionCard-image"
            loading={priority ? "eager" : "lazy"}
            fetchPriority={priority ? "high" : "auto"}
            decoding={priority ? undefined : "async"}
          />
        </div>
        <div className="CollectionCard-content">
          <p className="CollectionCard-subtitle">{subtitle}</p>
          <h2 className="CollectionCard-title">{title}</h2>
          <h3 className="CollectionCard-sub-header">{sub_header}</h3>
        </div>
      </Link>
    </li>
  );
};

CollectionCard.propTypes = {
  collection: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    resizedSmallImage: PropTypes.string.isRequired,
    sub_header: PropTypes.string,
  }).isRequired,
  priority: PropTypes.bool,
};

CollectionCard.displayName = "CollectionCard";

export default React.memo(CollectionCard);
